import Vue from 'vue';
import VueRouter from 'vue-router';
import MesLayout from '@/components/layout';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/home/index'
  },
  {
    path: '/redirect',
    name: 'redirect',
    component: MesLayout,
    children: [
      {
        path: '/redirect/:path(.*)',
        name: 'redirectIndex',
        component: () => import('@/views/redirect/index.vue')
      }
    ]
  },
  {
    path: '/403',
    name: 'error403',
    component: () => import('@/views/error/403.vue'),
    meta: {
      title: '403'
    }
  },
  {
    path: '/404',
    name: 'error404',
    component: () => import('@/views/error/404.vue'),
    meta: {
      title: '404'
    }
  },
  {
    path: '/500',
    name: 'error500',
    component: () => import('@/views/error/500.vue'),
    meta: {
      title: '500'
    }
  }
];

const createRouter = () => new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, form, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    return {
      y: 0
    };
  },
  routes
});

const router = createRouter();

// 重置路由
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
}

// 处理路由跳转报错
['push', 'replace'].forEach(type => {
  const original = VueRouter.prototype[type];
  VueRouter.prototype[type] = function type(location) {
    return original.call(this, location).catch(err => err);
  };
});

export default router;